import { createReducer, createAction } from '@reduxjs/toolkit'

export type ToastType = 'success'

export interface ToastState {
  id: number
  message: string
  type: ToastType
  visible: boolean
  actionLabel: string | null
  actionPath: string | null
}

const initialState: ToastState = {
  id: 0,
  message: '',
  type: 'success',
  visible: false,
  actionLabel: null,
  actionPath: null
}

export const SHOW_TOAST = createAction<{
  message: string
  type?: ToastType
  actionLabel?: string
  actionPath?: string
}>('toast_reducer/show')
export const HIDE_TOAST = createAction('toast_reducer/hide')

export const toastReducer = createReducer(initialState, (builder) => {
  builder.addCase(SHOW_TOAST, (state, action) => {
    return {
      id: state.id + 1,
      message: action.payload.message,
      type: action.payload.type ?? 'success',
      visible: true,
      actionLabel: action.payload.actionLabel ?? null,
      actionPath: action.payload.actionPath ?? null
    }
  })
  builder.addCase(HIDE_TOAST, (state) => {
    return { ...state, visible: false }
  })
})
